// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_tu-0";
export var checkoutRateBadgeLink = "_tu-1";